import React, {Component, Fragment} from 'react';
import Table, {TableColumn} from "./Table";
import Shortcutter, {IShortcutRadialOption} from "./Shortcutter";
import TableCell from "./TableCell";
import * as _ from "lodash";

interface ShortcutterInfoProps {
}

interface ShortcutterInfoState {
}


export default class ShortcutterInfo extends Component<ShortcutterInfoProps, ShortcutterInfoState> {
    static displayName = ShortcutterInfo.name;

    private static readonly columns = [
        {
            title: "Keys",
            propertyPath: "keys",
            flex: 1
        },
        {
            title: "description",
            propertyPath: "description",
            flex: 1
        }
    ];

    constructor(props: ShortcutterInfoProps) {
        super(props);

        this.state = {
        }
    }

    async componentDidMount() {
    }

    async componentDidUpdate(prevProps: Readonly<ShortcutterInfoProps >, prevState: any): Promise<void> {

    }

    private cellForColumn = (item: IShortcutRadialOption, column: TableColumn, index: number): JSX.Element | undefined => {

        if(column.propertyPath === "keys")
        {
            return (
                <TableCell key={column.propertyPath} flex={column.flex}>
                    <span>ALT + {item.keyCode.split("Key")[1]}</span>
                </TableCell>
            );
        }

        if(column.propertyPath === "description")
        {
            if(item.keyCode === Shortcutter.radialShortcutKeyCode)
            {
                return (
                    <TableCell key={column.propertyPath} flex={column.flex}>
                        <span>Open radial menu</span>
                        <span className={"text-extra-detail"}>{item.title}</span>
                    </TableCell>
                );
            }
            else
            {
                return (
                    <TableCell key={column.propertyPath} flex={column.flex}>
                        <span>Go to {item.title}</span>
                        <span className={"text-extra-detail"}>{item.url}</span>
                    </TableCell>
                );
            }
        }

        return;
    }

    render() {
        
        const generalShortcuts: IShortcutRadialOption[] = [
            {
                title: "With general shortcuts",
                keyCode: Shortcutter.radialShortcutKeyCode,
                url: "",
                id: ""
            },
            ...Shortcutter.nonSchoolOptions
        ];
        
        const schoolSpecificShortcuts: IShortcutRadialOption[] = [
            {
                title: "With school specific shortcuts",
                keyCode: Shortcutter.radialShortcutKeyCode,
                url: "",
                id: ""
            },
            ...Shortcutter.buildSchoolOptions("TENANT_ID","SCHOOL_CODE")
        ];
        
        return (
            <Fragment>
                <Table title={"General Shortcuts"} columns={ShortcutterInfo.columns} cellForColumn={this.cellForColumn} items={generalShortcuts}/>
                <Table title={"School Specific Shortcuts"} columns={ShortcutterInfo.columns} cellForColumn={this.cellForColumn} items={schoolSpecificShortcuts}/>
            </Fragment>
        );
    }
}